import { Injectable, signal } from '@angular/core';
import { ScreenSize } from '../enums';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    private readonly _screenSize = signal<ScreenSize>(ScreenSize.XSmall);
    readonly screenSize = this._screenSize.asReadonly();

    setScreenSize(screenSize: ScreenSize): void {
        this._screenSize.set(screenSize);
    }
}
